import { IFarmConfiguration, IUser } from 'src/@types/User'

export interface AuthState {
  user: IUser | null
  farmConfig?: IFarmConfiguration | null
  token: string | null
  loading: boolean
  tokenExpired: boolean
  statusLogin: string
}

export const initialAuthState: AuthState = {
  user: null,
  token: null,
  farmConfig: null,
  loading: true,
  tokenExpired: true,
  statusLogin: ''
}

export type AuthAction =
  | {
      type: 'LOGIN_SUCCESS'
      payload: {
        user: IUser
        token: string
        farmConfig?: IFarmConfiguration
      }
    }
  | {
      type: 'HYDRATE_SESSION'
      payload: {
        user: IUser | null
        token: string | null
        farmConfig?: IFarmConfiguration
      }
    }
  | {
      type: 'HYDRATE_SESSION'
      payload: {
        user: IUser | null
        token: string | null
        farmConfig?: IFarmConfiguration
      }
    }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_STATUS_LOGIN'; payload: string }
  | {
      type: 'SET_CONFIRMATION_STATUS'
      payload: {
        phoneConfimed?: string
        emailConfimed?: string
      }
    }
  | { type: 'SET_USER_FARM'; payload: string }
  | { type: 'UPDATE_USER'; payload: Partial<IUser> }
  | { type: 'SESSION_EXPIRED' }
  | { type: 'LOGOUT' }

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        tokenExpired: true,
        loading: false,
        statusLogin: 'Logged',
        farmConfig: action.payload.farmConfig // Preserve the existing farmConfig
      }

    case 'HYDRATE_SESSION':
      return {
        ...state,
        user: action.payload.user,
        farmConfig: action.payload.farmConfig,
        token: action.payload.token,
        tokenExpired: true,
        loading: false
      }

    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload
      }

    case 'SET_STATUS_LOGIN':
      return {
        ...state,
        statusLogin: action.payload
      }

    case 'SET_CONFIRMATION_STATUS': {
      if (!state.user) return state

      return {
        ...state,
        user: {
          ...state.user,
          telefoneConfirmado: action.payload.phoneConfimed ?? state.user.telefoneConfirmado,
          emailConfirmado: action.payload.emailConfimed ?? state.user.emailConfirmado
        }
      }
    }

    case 'SET_USER_FARM': {
      if (!state.user) return state
      return {
        ...state,
        user: { ...state.user, idFazenda: action.payload }
      }
    }

    case 'UPDATE_USER': {
      if (!state.user) return state
      return {
        ...state,
        user: { ...state.user, ...action.payload }
      }
    }

    case 'SESSION_EXPIRED':
      return {
        ...initialAuthState,
        loading: false,
        tokenExpired: false
      }

    case 'LOGOUT':
      return {
        ...initialAuthState,
        loading: false
      }

    default:
      return state
  }
}
